// src/components/main/asgSection/PlataformaContent.tsx
import React from 'react';
import { Button } from '@mui/material';
import useStyles from './styles';

const PlataformaContent: React.FC = () => {
  const classes = useStyles();

  return (
    <section id="plataforma" className={classes.section}>
      <div className={classes.textContainer}>
        <h1 className={classes.heading}>OrkestaMedia, el compás perfecto para tus campañas</h1>
        <p className={classes.paragraph}>
          Orquesta cada movimiento con precisión, domina los resultados y proyecta el éxito con inteligencia.
        </p>
        <Button variant="outlined" href='#contacto' className={classes.button}>
          Descubre cómo funciona
        </Button>
      </div>
    </section>
  );
};

export default PlataformaContent;